import React from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Modal from 'ds/components/modal';
import { Button } from 'ds/components/button';
import { H3, Text } from 'ds/components/typography';
import InfoSignIcon from 'assets/svg/private-bulletin-promotion/modal-info-sign.svg';
import { useLocale } from 'locale';
import { RootAction, State } from 'store/state';
import { setCancelUserPromotionPlanResultModal } from 'store/state/app/actions';
import { isCancelUserPromotionPlanResultModalOpenSelector } from 'store/state/app/private-user-monetization/selectors';

const Root = styled.div(({ theme }) => ({
  width: '100%',
  maxWidth: '320px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(1),
}));

const Header = styled(H3)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1.5),
  color: theme.colors.neutrals.grey1,
}));

const Description = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
  marginBottom: theme.spacing(3),
  whiteSpace: 'pre-line',
}));

interface CancelUserPromotionPlanResultModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CancelUserPromotionPlanResultModal: React.FC<CancelUserPromotionPlanResultModalProps> = (props) => {
  const { isOpen, onClose } = props;
  const { t } = useLocale();

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      desktopModalPositionCenter
      mobileModalPositionBottom
      hideCloseButton
    >
      <Root>
        <InfoSignIcon width={88} height={88} />
        <Header weight="bold">
          {t('manageBulletinPage.bulletin.cancelSubscriptionSuccessModal.title')}
        </Header>
        <Description>
          {t('manageBulletinPage.bulletin.cancelSubscriptionSuccessModal.description')}
        </Description>
        <Button fullWidth size="extraLarge" onClick={onClose}>
          {t('manageBulletinPage.bulletin.cancelSubscriptionSuccessModal.confirm')}
        </Button>
      </Root>
    </Modal>
  );
};

const mapStateToProps = (state: State) => ({
  isOpen: isCancelUserPromotionPlanResultModalOpenSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onClose: () => dispatch(setCancelUserPromotionPlanResultModal({ isOpen: false })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelUserPromotionPlanResultModal);
